import useTitle from "../../hooks/useTitle"
import {  useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import UserQuestionList from "./UserQuestionList"
function UserQuestionListFilter() {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: QuestionSets List')
    const [q,setQ] = useState('')



    const navigate = useNavigate()

   
   
    const content =(<>
    <div className="filter-form">
  
                  
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            </div>
    </div>
 <UserQuestionList  q={q}   />
</> ) 
  return content;
}

export default UserQuestionListFilter